<template>
  <div>
    <span v-if="scope.productStatus == '0'" style="color:#606266;">{{ $t('addConfigModule.batchProduction') }}</span>
    <span v-if="scope.productStatus == '1'" style="color: red;">
      <span v-if="scope.formalStopTime != null">{{ delistingStatus(scope.recordLockingDate,scope.formalStopTime) }}</span>
    </span>
    <span v-if="scope.productStatus == '2'" style="color: red;">{{ $t('addConfigModule.remainingInventoryClearing') }}</span>
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
export default {
  name: 'ProductStatusFomation',
  props: {
    scope: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data () {
    return {

    };
  },
  methods: {
    delistingStatus (recordLockingDate, formalStopTime) {
      if (recordLockingDate != null && recordLockingDate != '') {
        if (XEUtils.now() - XEUtils.timestamp(recordLockingDate, 'yyyy-MM-dd') <= 0) {
          return recordLockingDate + this.$t('addConfigModule.reportingLock');
        } else if (
          formalStopTime != null &&
              XEUtils.now() - XEUtils.timestamp(recordLockingDate, 'yyyy-MM-dd') > 0 &&
              XEUtils.now() - XEUtils.timestamp(formalStopTime, 'yyyy-MM-dd') <= 0
        ) {
          return formalStopTime + this.$t('addConfigModule.stopPlacingAnOrder');
        } else {
          return this.$t('addConfigModule.stopPlacingAnOrder');
        }
      } else {
        if (formalStopTime != null) {
          return formalStopTime + this.$t('addConfigModule.stopPlacingAnOrder');
        } else {
          return this.$t('addConfigModule.stopPlacingAnOrder');
        }
      }
    }
  }
};
</script>

<style scoped>

</style>
